import ArticleLoader from "../components/article-loader";

const test = ({
  __typename,
  staticType,
}: {
  __typename: string;
  staticType: string;
}): boolean => {
  return (
    __typename === "VinoData_StaticBlock" &&
    (staticType === "Article Loader" || staticType === "Whiskymofo Article Loader")
  );
};
const create = ({
  __typename,
  staticType,
}: {
  __typename: string;
  staticType: string;
}): JSX.Element => {

  return (
    <ArticleLoader __typename={__typename} staticType={staticType} />
  );
};

export default { test, create };
